/// <amd-module name="Feed/Legacy/Components/WrappedCreateFeedPanel" />
import * as React from "react";
import { connect } from "react-redux";

import { IVssComponentContext, WrappedComponent } from "VSS/Platform/Layout";

import { IFeedHubViewState } from "Feed/Core/Redux/FeedHub/FeedHubContracts";

interface ICreateFeedPanelProps {
    show: boolean;
}

/**
 * Dynamically loads the feed-createfeed bundle and instantiates the global settings panel component
 */
class CreateFeedPanel extends React.Component<ICreateFeedPanelProps> {
    constructor(props: ICreateFeedPanelProps, context?: IVssComponentContext) {
        super(props, context);
    }

    public render() {
        const show = this.props.show;
        return show ? (
            <WrappedComponent
                dependencies={["ms.feed.feed-createfeed"]}
                wrappedType="ms.feed.feed-createfeed.create-feed-panel"
            />
        ) : null;
    }
}

function mapStateToProps(state: IFeedHubViewState): ICreateFeedPanelProps {
    return {
        show: state.ui.showCreateFeed
    };
}

export const WrappedCreateFeedPanel = connect(mapStateToProps)(CreateFeedPanel);
